import React from 'react';
import { LinearProgress, Stack } from '@mui/material';
import { theme } from '../../../../../../common/styles/theme';
import { Text } from '../../../../../../common/components/Text/Text';

// No real progress to report — the backend does it all in one request — so the line just advances
// on a timer to show the wait is still going somewhere.
const STEP_MS = 4000;

export const CREATE_MESSAGES = [
	'Preparing your book…',
	'Reading the lesson transcript…',
	'Picking out key vocabulary…',
	'Writing the first page…',
	'Almost there…',
];

export const REGENERATE_MESSAGES = [
	'Rewriting the first page…',
	'Almost there…',
];

export interface IBookProgressProps {
	title: string;
	messages: string[];
}

export const BookProgress: React.FC<IBookProgressProps> = ({ title, messages }) => {
	const [step, setStep] = React.useState(0);
	React.useEffect(() => {
		const timer = window.setInterval(() => setStep(s => Math.min(s + 1, messages.length - 1)), STEP_MS);
		return () => window.clearInterval(timer);
	}, [messages]);

	return (
		<Stack
			alignItems={'center'}
			justifyContent={'center'}
			gap={1.5}
			sx={{ flex: '1 1 auto', minHeight: 0, p: 3, textAlign: 'center' }}
		>
			<Text sx={{ fontSize: theme.typography.subtitle2, fontWeight: 600 }}>{title}</Text>
			<Text sx={{ fontSize: theme.typography.subtitle1, color: theme.palette.grey[500] }}>{messages[step]}</Text>
			<LinearProgress sx={{ width: theme.spacing(30), borderRadius: 1 }} />
		</Stack>
	);
};
